
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  fetchKeysAction,
  createKeyAction,
  clearLastErrorAction,
} from '../../store/keyManager/keyManagerReducers';

import bottle from './bottle';

// eslint-disable-next-line prefer-destructuring
const KeyManagerContainer = bottle().container.KeyManagerContainer;

const mapStateToProps = state => ({
  progress: state.keyManager.progress,
  keys: state.keyManager.keys,
  bearerToken: state.keyManager.bearerToken,
  lastError: state.keyManager.lastError,
  loading: state.keyManager.loading,
});

const mapDispatchToProps = dispatch => ({
  fetchKeys: () => dispatch(fetchKeysAction()),
  createKey: () => dispatch(createKeyAction()),
  clearLastError: () => dispatch(clearLastErrorAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(KeyManagerContainer));
